// import { users } from "./reducer";

export const fetchUsers = () => {
  return {
    type: contactActions.FETCH_USERS,
  };
};

export const fetchUsersSuccess = (users) => ({
  type: contactActions.FETCH_USERS_SUCCESS,
  payload: { users },
});

export const fetchInvites = () => ({
  type: "FETCH_INVITES",
});

export const addInvite = (invite) => ({
  type: "ADD_INVITE",
  payload: invite,
});

export const fetchWorkouts = (id) => {
  console.log("in fetch workouts");
  return {
    type: contactActions.FETCH_WORKOUTS,
    id,
  };
};

export const fetchWorkoutsSuccess = (workouts) => ({
  type: contactActions.FETCH_WORKOUTS_SUCCESS,
  payload: { workouts },
});

export const fetchFullWorkout = (workout_uuid) => ({
  type: contactActions.FETCH_FULL_WORKOUT,
  workout_uuid: workout_uuid,
});

export const fetchFullWorkoutSuccess = (serieslogs) => ({
  type: contactActions.FETCH_FULL_WORKOUT_SUCCESS,
  payload: serieslogs,
});

function ascendingSort(contact1, contact2) {
  const name1 = contact1.name ? contact1.name.toUpperCase() : "~";
  const name2 = contact2.name ? contact2.name.toUpperCase() : "~";
  return name1 > name2 ? 1 : name1 === name2 ? 0 : -1;
}

const contactActions = {
  ADD_CONTACT: "ADD_CONTACT",
  EDIT_CONTACT: "EDIT_CONTACT",
  DELETE__CONTACT: "DELETE__CONTACT",
  CHANGE_CONTACT: "CHANGE_CONTACT",
  CHANGE_CONTACT_SUCCESS: "CHANGE_CONTACT_SUCCESS",
  EDIT_VIEW: "EDIT_VIEW",
  FETCH_USERS: "FETCH_USERS",
  FETCH_USERS_SUCCESS: "FETCH_USERS_SUCCESS",
  FETCH_WORKOUTS: "FETCH_WORKOUTS",
  FETCH_WORKOUTS_SUCCESS: "FETCH_WORKOUTS_SUCCESS",
  SAVE_USERS: "SAVE_USERS",
  FETCH_FULL_WORKOUT: "FETCH_FULL_WORKOUT",
  FETCH_FULL_WORKOUT_SUCCESS: "FETCH_FULL_WORKOUT_SUCCESS",
  UPDATE_USER: "UPDATE_USER",
  SELECT_WORKOUT: "SELECT_WORKOUT",
  SHOW_ADD_USER_MODAL: "SHOW_ADD_USER_MODAL",
  ADD_USER: "ADD_USER",
  SET_TEAMS: "SET_TEAMS",
  ADD_TEAM: "ADD_TEAM",
  PATCH_USER: "PATCH_USER",
  changeContact: (id, tracking_type) => ({
    type: contactActions.CHANGE_CONTACT,
    tracking_type: tracking_type,
    id,
  }),
  changeContactSuccess: (id, tracking_type) => ({
    type: contactActions.CHANGE_CONTACT_SUCCESS,
    tracking_type: tracking_type,
    id,
  }),

  editContact: (newContact) => {
    return (dispatch, getState) => {
      const contacts = getState().Contacts.get("contacts");
      const newContacts = [];
      contacts.forEach((contact) => {
        if (contact.id === newContact.id) {
          newContacts.push(newContact);
        } else {
          newContacts.push(contact);
        }
      });
      dispatch({
        type: contactActions.EDIT_CONTACT,
        contacts: newContacts.sort(ascendingSort),
      });
    };
  },
  deleteContact: (id) => {
    return (dispatch, getState) => {
      const contacts = getState().Contacts.get("contacts");
      const seectedId = getState().Contacts.get("seectedId");
      const newContacts = [];
      contacts.forEach((contact) => {
        if (contact.id === id) {
        } else {
          newContacts.push(contact);
        }
      });
      dispatch({
        type: contactActions.DELETE__CONTACT,
        contacts: newContacts,
        seectedId: id === seectedId ? undefined : seectedId,
      });
    };
  },
  viewChange: (view) => ({
    type: contactActions.EDIT_VIEW,
    view,
  }),
};
export default contactActions;

export const updateUser = (user) => ({
  type: contactActions.UPDATE_USER,
  payload: user,
});

export const select_workout = (workout) => ({
  type: contactActions.SELECT_WORKOUT,
  payload: workout,
});

export const showAddUserModal = (value) => ({
  type: contactActions.SHOW_ADD_USER_MODAL,
  payload: value,
});

export const addUser = (user) => ({
  type: contactActions.ADD_USER,
  payload: user,
});

export const setTeams = (payload) => ({
  type: contactActions.SET_TEAMS,
  payload,
});

export const addTeam = (payload) => ({
  type: contactActions.ADD_TEAM,
  payload,
});

export const patchUsers = (payload) => ({
  type: contactActions.PATCH_USER,
  payload,
});
